import { Controller } from "@hotwired/stimulus"

// PΔ.301.1 — экран ожидания: опрашивает API и подсвечивает пройденные шаги.
// Когда диагностика готова или упала — перезагружает страницу, сервер отрисует отчёт.
export default class extends Controller {
  static targets = ["step"]
  static values = { endpoint: String, interval: { type: Number, default: 2000 } }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async tick() {
    try {
      const resp = await fetch(this.endpointValue, { headers: { "Accept": "application/json" }, cache: "no-store" })
      if (!resp.ok) return
      const data = await resp.json()
      this.render(data)
      if (data.status === "done" || data.status === "failed") {
        clearInterval(this.timer)
        window.location.reload()
      }
    } catch (_) {
      // сеть моргнула — следующий тик повторит
    }
  }

  render(data) {
    const passed = new Set((data.progress?.steps || []).map(s => s.key))
    const current = data.progress?.current
    this.stepTargets.forEach(el => {
      const key = el.dataset.step
      const dot = el.querySelector('[data-role="dot"]')
      el.classList.toggle("opacity-50", !passed.has(key) && key !== current)
      if (!dot) return
      dot.className = "h-2.5 w-2.5 rounded-full " +
        (key === current && data.status === "running" ? "bg-emerald-500 animate-pulse"
          : passed.has(key) ? "bg-emerald-600" : "bg-slate-300")
    })
  }
}
